import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface ActionMenuItem {
  label: string;
  icon?: string;
  routerLink?: unknown[];
  clickAction?: string;
  data?: unknown;
  visible?: boolean;
  modalTarget?: string;
}

@Component({
  selector: 'app-action-menu',
  templateUrl: './action-menu.component.html',
  styleUrls: ['./action-menu.component.scss']
})
export class ActionMenuComponent {
  @Input() menuItems: ActionMenuItem[] = [];
  @Input() itemId!: string | number;

  @Output() itemSelected = new EventEmitter<{action: string, id: string | number, data?: unknown}>();

  onItemClick(item: ActionMenuItem): void {
    this.itemSelected.emit({
      action: item.label,
      id: this.itemId,
      data: item.data
    });
  }
}
